// extracted by mini-css-extract-plugin
module.exports = {"bar":"ProgressBar_bar__1iFPY","progress":"ProgressBar_progress__kI-Tn"};